<template>
   <form @submit.prevent>
      <CModal
         :title.sync="title"
         color="info"
         :closeOnBackdrop="false"
         :show.sync="show"
      >
         <CRow>
            <CCol>
               <label> Class Name </label>
               <CRow>
                  <CCol>
                     <b-input
                        v-model="form.name"
                        placeholder="Class name"
                        :state="validationName"
                        id="feedback-user"
                        class="mb-1"
                     >
                     </b-input>
                     <b-form-invalid-feedback :state="validationName">
                        Your class name must be filled
                     </b-form-invalid-feedback>
                     <b-form-valid-feedback :state="validationName">
                        Looks Good.
                     </b-form-valid-feedback>
                  </CCol>
               </CRow>
            </CCol>
         </CRow>
         <CRow class="mt-3">
            <CCol>
               <label>Description Class </label>
               <CRow>
                  <CCol sm="12">
                     <c-textarea
                        v-model="form.description"
                        rows="4"
                        class="mb-3"
                     />
                  </CCol>
               </CRow>
               <CRow>
                  <CCol sm="12">
                     <label>Category Class </label>
                     <!-- <label> <b> Category Event  </b></label> -->
                     <b-form-group v-slot="{ ariaDescribedby }">
                        <b-form-radio-group
                           v-model="form.is_publish"
                           :aria-describedby="ariaDescribedby"
                        >
                           <b-form-radio
                              :aria-describedby="ariaDescribedby"
                              name="category"
                              value="1"
                              >Public</b-form-radio
                           >
                           <b-form-radio
                              :aria-describedby="ariaDescribedby"
                              name="category"
                              value="2"
                              >Private</b-form-radio
                           >
                        </b-form-radio-group>
                     </b-form-group>
                  </CCol>
               </CRow>
               <CRow hidden>
                  <CCol sm="12">
                     <label>Type Class </label>
                     <!-- <label> <b> Category Event  </b></label> -->
                     <b-form-group v-slot="{ ariaDescribedby }">
                        <b-form-radio-group
                           v-model="form.type"
                           :aria-describedby="ariaDescribedby"
                        >
                           <b-form-radio
                              :aria-describedby="ariaDescribedby"
                              name="category"
                              value="1"
                              >Singleclass</b-form-radio
                           >
                           <b-form-radio
                              :aria-describedby="ariaDescribedby"
                              name="category"
                              value="2"
                              >Multiclass</b-form-radio
                           >
                        </b-form-radio-group>
                     </b-form-group>
                  </CCol>
               </CRow>
               <CRow>
                  <CCol>
                     <label>Batch</label>
                     <model-select
                        v-model="form.batch_id"
                        :options="options"
                     ></model-select>
                  </CCol>
               </CRow>
            </CCol>
         </CRow>
         <template #footer>
            <CButton @click="show = false" color="danger">Cancel</CButton>
            <CButton
               v-if="mode === 'create'"
               type="submit"
               v-on:click.prevent="create()"
               variant="outline"
               color="info"
               >Create</CButton
            >
            <CButton
               v-if="mode === 'edit'"
               type="submit"
               v-on:click.prevent="update(form.id)"
               variant="outline"
               color="info"
               >Edit</CButton
            >
         </template>
      </CModal>
   </form>
</template>

<script>
import EventBus from "@/eventBus";

import classtemplate from "@/services/class_template";
import classbatch from "@/services/batch";
import { ModelSelect } from "vue-search-select";

export default {
   name: "classtemplatemodal",
   components: {
      ModelSelect,
   },

   data() {
      return {
         show: false,
         title: "Default Title",
         mode: "",
         form: {
            id: "",
            name: "",
            description: "",
            is_publish: "1",
            type: "2",
            batch_id: "",
         },
         options: [],
      };
   },
   computed: {
      validationName() {
         return this.form.name.length > 0;
      },
   },
   mounted() {},

   created() {
      var self = this;
      EventBus.$on("OPEN_MODAL_CLASS", (params) => {
         if (params.data) {
            classtemplate
               .getTemplatebyID(params.data)
               .then((res) => {
                  self.show = true;
                  self.title = params.title;
                  self.mode = params.mode;
                  self.form.id = res.data.id;
                  self.form.name = res.data.name;
                  self.form.description = res.data.description;
                  self.form.is_publish = res.data.is_publish;
                  self.form.type = res.data.type;
                  self.form.batch_id = res.data.class_batch.id;
               })
               .catch((err) => {
                  var params = {
                     title: "Error",
                     mode: "danger",
                     data: err.response.data.message,
                  };
                  EventBus.$emit("OPEN_MODAL_ALERT", params);
               });
         } else {
            self.show = true;
            self.title = params.title;
            self.mode = params.mode;
            self.form.id = "";
            self.form.name = "";
            self.form.description = "";
            self.form.is_publish = "";
            self.form.type = "2";
            self.form.batch_id = "";
         }
      });
      classbatch
         .getBatch()
         .then((res) => {
            for (let i = 0; i <= res.data.length; i++) {
               //alert
               this.options.push({
                  text: res.data[i].name,
                  value: res.data[i].id,
               });
            }
         })
         .catch((er) => {});
   },

   methods: {
      open() {
         this.show = true;
      },
      close() {
         this.show = false;
      },
      create() {
         this.show = false;
         classtemplate
            .createTemplate(this.form)
            .then((res) => {
               EventBus.$emit("TABLE_UPDATE", true);
               var params = {
                  title: "Success",
                  mode: "success",
                  data: res.message,
               };
               EventBus.$emit("OPEN_MODAL_ALERT", params);
            })
            .catch((err) => {
               var params = {
                  title: "Error",
                  mode: "danger",
                  data: err.response.data.message,
               };
               EventBus.$emit("OPEN_MODAL_ALERT", params);
            });
      },
      update(id) {
         this.show = false;
         classtemplate
            .updateTemplate(id, this.form)
            .then((res) => {
               EventBus.$emit("TABLE_UPDATE", true);
               var params = {
                  title: "Success",
                  mode: "success",
                  data: res.message,
               };
               EventBus.$emit("OPEN_MODAL_ALERT", params);
            })
            .catch((err) => {
               var params = {
                  title: "Error",
                  mode: "danger",
                  data: err.response.data.message,
               };
               EventBus.$emit("OPEN_MODAL_ALERT", params);
            });
      },
   },
};
</script>

<style></style>
